export default "__VITE_ASSET__debba241__"